module.exports = __webpack_public_path__ + "img/eshop.62d4e17d.png";